import { https } from "../http";
import store from "../store";
import { setDefaultSupports, setDefaultSupportsLoading } from "../store/reducers/activityLibrary";
import { showError } from "../utils/index";

// Default support-method picks are per-admin (scoped server-side to the
// authenticated user via the Bearer token), not client-side/localStorage.

// GET
const getDefaultPrompting = async (showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setDefaultSupportsLoading(true));
    let response = await https().get("/default-prompting");

    if (response?.status === 200) {
      store.dispatch(setDefaultSupports(response?.data?.data?.supportMethods || null));
    }
  } catch (error) {
    // Silent — no saved default yet isn't an error state worth interrupting for.
    store.dispatch(setDefaultSupportsLoading(false));
  }
};

// PUT
const saveDefaultPrompting = async (supportMethods, callback) => {
  try {
    let response = await https().put("/default-prompting", { supportMethods });

    if (response?.status === 200) {
      store.dispatch(setDefaultSupports(supportMethods));
      callback?.();
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export { getDefaultPrompting, saveDefaultPrompting };
